module.exports = __webpack_public_path__ + "static/media/LoaderViolet.518ee22e.svg";